interface Props {
  planLength: "annual" | "monthly";
  setPlanLength: (l: "annual" | "monthly") => unknown;
}

const PlanLengthSelect = ({ planLength, setPlanLength }: Props) => {
  return (
    <div className="text-center">
      <label
        className="inline-block mb-4 text-xl"
        htmlFor="billing-monthly"
        onClick={() => setPlanLength("monthly")}
      >
        <input
          className="mr-2"
          type="radio"
          name="billing-monthly"
          value="1"
          checked={planLength === "monthly"}
          onChange={() => {}}
        />
        <span>Monthly Billing</span>
      </label>
      <br className="lg:hidden" />
      <label
        className="text-xl md:ml-4"
        htmlFor="billing-annual"
        onClick={() => setPlanLength("annual")}
      >
        <input
          className="mr-2"
          type="radio"
          name="billing-annual"
          value="2"
          checked={planLength === "annual"}
          onChange={() => {}}
        />
        <span>
          Yearly{" "}
          <span className="text-base text-green-600">(Save Upto 37%)</span>
        </span>
      </label>
    </div>
  );
};

export default PlanLengthSelect;
